import { Transition } from "@headlessui/react";
import clsx from "clsx";
import { Fragment } from "react";

const BackdropComponent: React.FC<{ blur?: boolean }> = (props) => {
  return (
    <Transition.Child
      as={Fragment}
      enter="ease-out duration-50"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="ease-in duration-50"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div
        className={clsx(
          "fixed inset-0 w-screen h-screen ",
          props?.blur ? "backdrop-blur-[6px]" : "bg-gray-800 opacity-75",
        )}
      />
    </Transition.Child>
  );
};

export default BackdropComponent;
